import React, {useState, useEffect} from "react";
import {ListSlides, ListHomeBlocks, UpdateBlockHome, CreateBlockHome} from "../services/GeneralServices";
import {getTestimonialsService} from "../services/CoursesServices";

export const HomeContext = React.createContext({});

export default function HomeProvider({children}) {
   const [isLoading, setLoading] = useState({slides: true});
   const [slidesHome, setSlides] = useState([]);
   const [currentBlocks, setCurrentBlocks] = useState([]);
   const [blocksHome, setBlocks] = useState([]);
   const [testimonialsList, setTestimonials] = useState([]);

   const getSlidesHome = () => {
      if (slidesHome.length >= 1) return false;
      ListSlides()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setSlides(data);
         })
         .then(() => {
            setLoading({...isLoading, slides: false});
         })
         .catch((e) => {
            console.log(e);
         });
   };

   const updateSlide = (slide) => {
      let newSlides = slidesHome.map((item) => {
         if (item.idSlideHome === slide.idSlideHome) {
            return {...slide};
         }
         return item;
      });
      setSlides(newSlides);
   };

   const addClean = () => {
      if (slidesHome.length >= 5) return false;
      let newSlides = [...slidesHome, {...cleanSlide}];
      setSlides(newSlides);
   };

   const getBlocks = () => {
      ListHomeBlocks()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setBlocks(data);
            setCurrentBlocks(data);
         })
         .catch((e) => {
            console.log(e);
         });
   };

   const updateBlock = (idHomeBlock, newVal, key) => {
      console.log(idHomeBlock, newVal, key);
      let newSlides = currentBlocks.map((item) => {
         if (item.idHomeBlock === idHomeBlock) {
            return {...item, [key]: key === "idReference" ? Number(newVal) : newVal};
         }
         return item;
      });
      setCurrentBlocks(newSlides);
   };

   const addBlockClean = () => {
      let neew = [...currentBlocks, {type: "Facilitators", data: {}}];
      console.log(neew);
      setCurrentBlocks(neew);
   };

   const saveNewDats = () => {
      // comprobar que block cambio
      for (let blockA in currentBlocks) {
         if (!currentBlocks[blockA].idHomeBlock) {
            createBlock(currentBlocks[blockA]);
         } else {
            let thisItem = currentBlocks[blockA];
            let idTofind = thisItem.idHomeBlock;
            let sameBlock = blocksHome.find((item) => item.idHomeBlock === idTofind);
            if (!(thisItem.type === sameBlock.type) || !(thisItem.idReference === sameBlock.idReference)) {
               saveNews(thisItem);
            }
         }
      }
   };

   const saveNews = (item) => {
      UpdateBlockHome(item)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
         })
         .catch((e) => {
            console.log(e);
         });
   };
   const createBlock = (item) => {
      CreateBlockHome(item)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
         })
         .catch((e) => {
            console.log(e);
         });
   };

   const getTestimonials = () => {
      if (testimonialsList.length > 0) return null;
      getTestimonialsService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            console.log(data);
            setTestimonials(data);
         })
         .catch((e) => {
            console.log(e);
         });
   };
   return (
      <HomeContext.Provider
         value={{
            getSlidesHome,
            slidesHome,
            isLoading,
            updateSlide,
            addClean,
            getBlocks,
            blocksHome,
            updateBlock,
            addBlockClean,
            saveNewDats,
            currentBlocks,
            getTestimonials,
            testimonialsList,
         }}
      >
         {children}
      </HomeContext.Provider>
   );
}

let cleanSlide = {
   title: "",
   subtitle: "",
   link: "",
   pathImageWebDesktop: "",
   pathImageWebMobile: "",
};
